<div class="carousel">
  <!-- Carousel items -->
  @for (item of carouselItems; track item; let i = $index) {
    <div class="slide" [@slideInOut]="getState(i)">
      <ng-container [ngTemplateOutlet]="item.templateRef"></ng-container>
    </div>
  }

  <!-- Next/previous buttons -->
  @if (!hideControls && carouselItems?.length > 1) {
    <button class="control scroll prev" (click)="previous()">
      @if (hideArrowHighlights) {
        <mat-icon>chevron_left</mat-icon>
      } @else {
        <img src="../../assets/icons/icon-arrow-circle.svg" />
      }
    </button>
  }

  @if (!hideControls && carouselItems?.length > 1) {
    <button class="control scroll next" (click)="next()">
      @if (hideArrowHighlights) {
        <mat-icon>chevron_right</mat-icon>
      } @else {
        <img
          src="../../assets/icons/icon-arrow-circle.svg"
          class="flip-horizontal"
        />
      }
    </button>
  }

  <!-- Pagination -->
  @if (!hidePageIndicator && carouselItems?.length > 1) {
    <div class="pages">
      @for (item of carouselItems; track item; let i = $index) {
        <button class="control pager" (click)="scrollTo(i)">
          <div
            class="circle"
            [ngClass]="{ highlight: i === currentSlideIndex }"
          ></div>
        </button>
      }
    </div>
  }
</div>
